import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=431b42fb&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('431b42fb')) {
      api.createRecord('431b42fb', component.options)
    } else {
      api.reload('431b42fb', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=431b42fb&", function () {
      api.rerender('431b42fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JvfaaRUVaXoB/JS/comp/IncreaseNumber.vue"
export default component.exports